<template lang="pug">

  .claim-voucher-component
    form(@submit.prevent="claim", @keydown="form.onKeydown($event)", :class="{ 'has-errors': form.errors.any() }")
      form-group-row(:form="form", name="number", :label="$t('claim_voucher.number')")
        form-input(:form="form", name="number", :placeholder="$t('claim_voucher.number_placeholder')")
      form-group-row(:form="form", name="code", :label="$t('claim_voucher.code')")
        form-input(:form="form", name="code", type="password", :placeholder="$t('claim_voucher.code_placeholder')")
      .form-group.no-check
        v-button.btn-default(:loading="form.busy", block) {{ $t('claim_voucher.submit') }}

    modal.card-details-modal(v-if="showClaimDetails", @close="showClaimDetails = false")
      .v-modal-title {{ $t('claim_voucher.claimed') }}
      .v-modal-message.text-left
        .row.justify-content-center
          label.col-md-6.col-10.mb-0 {{ $t('claim_voucher.play_card_number') }}
          .col-md-6.text-right.col-10.mb-3
            .value {{ claimDetails.playcard.number }}

</template>

<script>
import Form from 'vform'

export default {
  name: 'claim-voucher',

  data: () => ({
    form: new Form({
      number: '',
      code: ''
    }),
    showClaimDetails: false,
    claimDetails: null
  }),

  methods: {
    async claim () {
      const {data} = await this.form.post(`${window.addiesaas.url}/api/playcards/voucher/claim`);
      this.claimDetails = data;
      this.showClaimDetails = true;
    }
  }
}
</script>
